import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import { capitalize } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriSwitch'
};

const styles = theme => ({
  root: {
    minWidth: 100,
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: `${theme.spacing(2)}px`,
    justifyItems: 'center',
    alignItems: 'center',
    position: 'relative',
    height: 32,
    borderRadius: 17,
    border: `1px solid currentColor`
  },
  colorPrimary: {
    color: theme.palette.info.main
  },
  colorSecondary: {
    color: theme.palette.secondary.main
  },
  fullWidth: {
    width: '100%'
  },
  text: {
    zIndex: 2,
    margin: 0,
    padding: theme.spacing(0, 2),
    textTransform: 'uppercase',
    transition: theme.transitions.create('color'),
    userSelect: 'none',
    fontWeight: 'bold',
    color: 'currentColor'
  },
  textActive: {
    color: theme.palette.common.white
  },
  indicator: {
    position: 'absolute',
    width: 'calc(50% + 1px)',
    height: 'calc(100% + 2px)',
    top: -1,
    left: -1,
    borderRadius: 17,
    zIndex: 1,
    backgroundColor: 'currentColor',
    transition: theme.transitions.create('transform')
  },
  indicatorActive: {
    transform: 'translate(100%)'
  },
  checkbox: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 1
  }
});

export const Switch = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    firstText,
    secondText,
    checked,
    onChange,
    defaultChecked,
    fullWidth,
    className,
    color = 'primary',
    classes
  } = props;
  const {
    current: controlled
  } = useRef(checked != null);
  const [value, setValue] = useState(Boolean(defaultChecked != null ? defaultChecked : checked));
  useEffect(() => {
    if (typeof checked === 'boolean') {
      setValue(checked);
    }
  }, [checked]);
  const handleChange = useCallback(event => {
    onChange == null ? void 0 : onChange(event);

    if (!controlled) {
      setValue(event.currentTarget.checked);
    }
  }, [onChange, controlled]);
  return /*#__PURE__*/_jsxs("label", {
    "data-testid": "label",
    className: clsx(classes.root, classes[`color${capitalize(color)}`], className, fullWidth && classes.fullWidth),
    htmlFor: id,
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(classes.indicator, value && classes.indicatorActive)
    }), /*#__PURE__*/_jsx(Typography, {
      className: clsx(classes.text, !value && classes.textActive),
      variant: "caption",
      children: firstText
    }), /*#__PURE__*/_jsx(Typography, {
      className: clsx(classes.text, value && classes.textActive),
      variant: "caption",
      children: secondText
    }), /*#__PURE__*/_jsx("input", {
      ref: ref,
      "data-testid": "input",
      id: id,
      type: "checkbox",
      checked: value,
      className: classes.checkbox,
      onChange: handleChange
    })]
  });
});
export default withStyles(styles, componentConfig)(Switch);